export default "__VITE_ASSET__f9d02480__"